import "./App.css";
import Home from "./pages/Home/Home";
import AboutUs from "./pages/AboutUs/AboutUs";
import Courses from "./pages/Courses/Courses";
import CoursesQM from "./pages/Courses/CoursesQM/CoursesQM";
import Pricing from "./pages/Pricing/Pricing";
import Contact from "./pages/Contact/Contact";
import Registration from "./pages/Registration/Registration";
import { Route, Switch } from "react-router-dom";
import Error from "./components/Error";
import CoursesQWT from "./pages/Courses/CoursesQWT/CoursesQWT";
import CoursesQT from "./pages/Courses/CoursesQT/CoursesQT";
import CoursesBQR from "./pages/Courses/CoursesBQR/CoursesBQR";
import CoursesLTQ from "./pages/Courses/CoursesLTQ/CoursesLTQ";
import CoursesBIK from "./pages/Courses/CoursesBIK/CoursesBIK";

import Container from "@mui/material/Container";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <div>
      
      <ScrollToTop/>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/courses" component={Courses} />
        <Route path="/aboutus" component={AboutUs} />
        <Route path="/courses/quranmemorization" component={CoursesQM} />
        <Route path="/courses/basicislamicknowledge" component={CoursesBIK} />
        <Route path="/courses/basicquranreading" component={CoursesBQR} />
        <Route path="/courses/learntenqirat" component={CoursesLTQ} />
        <Route path="/courses/quranwithtajweed" component={CoursesQWT} />
        <Route path="/courses/qurantranslation" component={CoursesQT} />
        <Route path="/pricing" component={Pricing} />
        <Route path="/contact" component={Contact} />
        <Route path="/Registration" component={Registration} />
        <Route component={Error} />
      </Switch>
      
    </div>
  );
}
export default App;
